import React from 'react';
import {
    FlexDiv,
    Heading1,
    TextDefault,
    ThemedButton,
} from '@awarego-ui/components';
import { useStores } from '../../hooks/use-stores';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Heading = styled(Heading1)`
    font-size: 28px;
`;

function InfosecFinish() {
    const { brandingStore, assessmentStore } = useStores();
    const { brandingLoaded, miniHraFinishUrl } = brandingStore;
    const { miniHRAFinishUrl, miniHRAOptions } = assessmentStore;
    const { t } = useTranslation();

    let linkUrl = miniHRAFinishUrl;
    if (!miniHRAOptions) {
        linkUrl =
            (brandingLoaded && miniHraFinishUrl) ||
            'https://awarego.com/human-risk-assessment/';
    }
    return (
        <FlexDiv alignCenter column padding={24} fullWidth>
            <TextDefault bold mb={8} lighter>
                {t('Human Risk Assessment')}
            </TextDefault>
            <Heading mb={4} center>
                {t('Well done!')}
            </Heading>
            {linkUrl && (
                <>
                    <TextDefault mb={16}>
                        {t(
                            'Click below to learn more about how you can assess human risk in your own organisation'
                        )}
                    </TextDefault>
                    <a href={linkUrl} target="_blank" rel="noreferrer">
                        <ThemedButton
                            mode="primary"
                            text={t('Learn more about HRA')}
                        />
                    </a>
                </>
            )}
        </FlexDiv>
    );
}

export default observer(InfosecFinish);
